<template>
  <div>
    <van-cell title="停机数合计:" :value='total' />
    <van-pull-refresh :disabled="refreshingFlag" v-model="refreshing" @refresh="onRefreshs" success-text="刷新成功">
      <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="onLoad" >
        <vanCollapseContent :list = list ></vanCollapseContent>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import vanCollapseContent from './EquipmentVanCollapseContent.vue'
import { EquipmentBeyond } from '@/api/Equipment.js'
export default {
  name: 'EquipmentvVanTab',
  components: { vanCollapseContent },
  props: {
    total: {
      type: Number
    },
    list: {
      type: Array
    },
    searchValue: {
      type: String
    },
    listFlag: {
      type: String
    }
  },
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      lists: [],
      totals: 0,
      paramsList: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        page: 1,
        limit: 10,
        iccid: this.searchValue
      },
      finishedText: '没有更多超流量设备了',
      // 刷新节流阀
      refreshingFlag: false
    }
  },
  watch: {
    listFlag: function (val) {
      if (val === 'three') {
        this.finishedText = '查询中...'
      } else if (val === 'two') {
        this.finishedText = '未查询到该设备'
      } else {
        this.finishedText = '没有更多超流量设备了'
      }
    }
  },
  computed: {},
  methods: {
    // 触底获取信息
    async onLoad () {
      if (this.searchValue) {
        this.$set(this.paramsList, 'iccid', this.searchValue)
      }
      const { data: res } = await EquipmentBeyond(this.paramsList)
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
      const { rows } = res.extend
      // this.lists.push(...rows)
      this.lists = rows
      this.totals = res.extend.records
      this.$emit('changList', {
        list: this.lists,
        total: this.totals,
        type: 'add'
      })
      this.loading = false
      if (rows.length >= this.paramsList.limit) {
        // 更新获取下一次数据的时间戳
        this.paramsList.page++
      } else {
        this.finished = true
      }
      this.refreshing = false
      this.$nextTick(_ => {
        this.refreshingFlag = false
      })
    },
    // 下拉刷新
    onRefreshs () {
      this.refreshingFlag = true
      // 清空列表数据
      this.finished = false
      this.lists = []
      this.totals = 0
      this.$emit('changList', {
        list: [],
        type: 'refreshs',
        total: 0
      })
      this.paramsList.page = 1
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    }
  },
  beforeCreate () {},
  created () {
  },
  mounted () {
  }
}
</script>

<style scoped lang='less'>
</style>
